/**
 * Shared utilities for interacting with Hotwire Native Bridge Components
 */

/**
 * Shows a native alert dialog on mobile devices using Joe Masilotti's bridge-components.
 * It creates a temporary button, attaches it to the DOM, and triggers its action.
 * 
 * @param element The container element to append the temporary button to
 * @param options Alert options (title, message, buttonText, isDestructive)
 */
export function showNativeAlert(
  element: HTMLElement,
  options: {
    title: string;
    message: string;
    buttonText: string;
    isDestructive?: boolean;
  }
): void {
  const { title, message, buttonText, isDestructive = false } = options;

  const button = document.createElement('button');
  button.dataset.controller = 'bridge--alert';
  button.dataset.action = 'click->bridge--alert#show';
  button.dataset.bridgeTitle = title;
  button.dataset.bridgeDescription = message;
  button.dataset.bridgeConfirm = buttonText;
  button.dataset.bridgeDismiss = ""; // Simple alert with one button
  
  if (isDestructive) {
    button.dataset.bridgeDestructive = "true";
  }

  button.style.display = 'none';
  element.appendChild(button);

  // We need a small delay for Stimulus to register the controller on the new element.
  // Using requestAnimationFrame twice is a common pattern to wait for the next render cycles.
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      button.click();
      // Clean up after the bridge has had time to process the click.
      // 1000ms is safe because the bridge call is synchronous to the native side.
      setTimeout(() => button.remove(), 1000);
    });
  });
}
